var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 39,
    viewBox: "0 0 54 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 80",
    d: "M0.867004 15C0.867004 6.71573 7.58273 0 15.867 0H38.3404C46.6246 0 53.3403 6.71573 53.3403 15V24C53.3403 32.2843 46.6246 39 38.3403 39H15.867C7.58272 39 0.867004 32.2843 0.867004 24V15Z",
    fill: "#59B8CA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "+",
    d: "M30.0563 22.88V27.94H23.7163V22.88H18.6562V16.58H23.7163V11.52H30.0563V16.58H35.0763V22.88H30.0563Z",
    fill: "#D9D9D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.6ce759299b06de282b51889a721986be.svg";
export { ForwardRef as ReactComponent };